import { CONSTANTS } from "@/constants";
import { useAuth } from "@/stores/useAuth";
import { useShallow } from "zustand/shallow";

export function UserName() {
    const [address, isLoading, profile_picture_url, username] = useAuth(
      useShallow((state) => [state.address, state.isLoading, state.profile_picture_url, state.username]),
    );
  
    if (isLoading) {
      return (
        <div className="flex items-center gap-1">
          <div className="w-5 h-5 relative rounded-full overflow-hidden">
            <img src={CONSTANTS.DEFAULT_AVATAR} alt="avatar" className="w-full h-full object-cover" />
          </div>
  
          {/* <Skeleton baseColor="#202020" highlightColor="#444" width={80} height={24} containerClassName="contents" /> */}
        </div>
      );
    }
  
    if (!address) {
      return <div className="h-12" />;
    }
  
    return (
      <div className="flex items-center gap-1 truncate">
        <div className="flex-shrink-0 w-5 h-5 relative rounded-full overflow-hidden">
          <img src={profile_picture_url} alt="avatar" className="w-full h-full object-cover" />
        </div>
        <p className="text-base text-white">{`@${username}`}</p>
      </div>
    );
  }